import { clsx, type ClassValue } from "clsx";
import { CheckCircle2, Clock, Loader2, XCircle } from "lucide-react";
import { twMerge } from "tailwind-merge";
import z from "zod";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const truncateText = (text: string, maxLength: number) => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + "...";
};

export const getStatusDetails = (status: string) => {
  switch (status) {
    case "pending":
      return {
        label: "قيد الانتظار",
        color: "bg-yellow-100 text-yellow-700 border-yellow-200",
        icon: Clock,
      };
    case "in_progress":
      return {
        label: "قيد التنفيذ",
        color: "bg-blue-100 text-blue-700 border-blue-200",
        icon: Loader2,
      };
    case "completed":
      return {
        label: "مكتمل",
        color: "bg-green-100 text-green-700 border-green-200",
        icon: CheckCircle2,
      };
    case "rejected":
      return {
        label: "مرفوض",
        color: "bg-red-100 text-red-700 border-red-200",
        icon: XCircle,
      };
    default:
      return {
        label: status,
        color: "bg-gray-100 text-gray-700 border-gray-200",
        icon: Clock,
      };
  }
};

export const projectSchema = z.object({
  nameAr: z.string().min(3, "اسم المشروع بالعربي مطلوب"),
  nameEn: z.string().min(3, "اسم المشروع بالإنجليزي مطلوب"),
  descAr: z.string().min(10, "الوصف بالعربي يجب أن يكون 10 أحرف على الأقل"),
  descEn: z.string().min(10, "الوصف بالإنجليزي يجب أن يكون 10 أحرف على الأقل"),
  developerId: z.string().min(1, "يرجى اختيار المطور العقاري"),
  projectImage: z
    .any()
    .refine((files) => files?.length > 0, "صورة المشروع مطلوبة"),
});
